import { _ as _extends } from './_rollupPluginBabelHelpers-8c92bac3.js';
import React__default from 'react';
import cx from 'classnames';
import { T as ThemeContext } from './ThemeContext-e1f446be.js';
import PropTypes from 'prop-types';

var styles = {"spacer":"Spacer-module_spacer__3O61e","showDivider":"Spacer-module_showDivider__1Ybgm","darkTheme":"Spacer-module_darkTheme__2q1eR","spacing_zero":"Spacer-module_spacing_zero__19jRt","spacing_xsmall":"Spacer-module_spacing_xsmall__1lZPS","spacing_small":"Spacer-module_spacing_small__1grkM","spacing_base":"Spacer-module_spacing_base__1IS_n","spacing_medium":"Spacer-module_spacing_medium__1b1eD","spacing_large":"Spacer-module_spacing_large__6tAar","spacing_xlarge":"Spacer-module_spacing_xlarge__2qYqR","spacing_xxlarge":"Spacer-module_spacing_xxlarge__3N9Gv"};

var lessVars = {"spacing_zero":"0","spacing_base":"24px","spacing_large":"40px","spacing_medium":"32px","spacing_small":"16px","spacing_xlarge":"48px","spacing_xsmall":"8px","spacing_xxlarge":"64px"};

const sizeDefs = Object.keys(lessVars).sort().map(k => k.replace('spacing_', ''));
class Spacer extends React__default.Component {
  render() {
    let {
      className,
      changeTheme,
      theme,
      size,
      darkThemeColour,
      defaultThemeColour,
      showDivider,
      tagName: TagName,
      ...p
    } = this.props; // eslint-disable-line no-unused-vars
    theme = this.props.theme || this.context.theme;
    if (!lessVars[`spacing_${size}`]) {
      console.warn(`\`Spacer\` element has an invalid size of \`${size}\``);
    }
    const classes = cx(className, styles.spacer, styles[`spacing_${size}`], {
      [styles.showDivider]: showDivider === true
    }, {
      [styles.darkTheme]: theme === 'dark'
    });
    return /*#__PURE__*/React__default.createElement(TagName, _extends({
      className: classes
    }, p));
  }
}
Spacer.contextType = ThemeContext;
Spacer.propTypes = {
  size: PropTypes.oneOf(sizeDefs),
  showDivider: PropTypes.bool
};
Spacer.defaultProps = {
  size: 'base',
  showDivider: false,
  tagName: 'div'
};

export default Spacer;
export { Spacer };
